var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isTaiwan)?_c('div',{staticClass:"header-comps-shop",attrs:{"data-tips":_vm.t('headerTools.shop')}},[_c('icon',{attrs:{"type":"mall","size":"22"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }